import { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { FaCaretDown, FaCheck } from "react-icons/fa6";
import { MediaManagerInstance } from "src/services/media-manager";

export default function DeviceSelector({
  options,
  defaultDeviceId,
  selectDeviceCallback,
  Icon,
}: {
  options: Array<MediaDeviceInfo>;
  defaultDeviceId: string | undefined;
  selectDeviceCallback?: (device: MediaDeviceInfo) => void;
  Icon?: IconType | undefined;
}) {
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (!opened) {
      MediaManagerInstance.checkDevices();
    }
  }, [opened]);

  // Find default device
  const defaultDeviceFound: MediaDeviceInfo | undefined = options.find(
    (d) => d.deviceId === defaultDeviceId
  );

  const selectDeviceHandler = (device: MediaDeviceInfo) => {
    setOpened(false);
    selectDeviceCallback && selectDeviceCallback(device);
  };

  return (
    <div className="device-selector-wrap">
      <button
        type="button"
        className="device-selector relative text-white border border-[#5f6368] w-full text-nowrap text-ellipsis overflow-hidden rounded-full px-2 py-2 ps-7 pe-5"
        onClick={() => setOpened(!opened)}
      >
        {Icon && (
          <Icon className="absolute text-blue-400 left-2 top-2/4 -translate-y-2/4" />
        )}
        <span>
          {!defaultDeviceFound
            ? "Nenhum dispositivo encontrado"
            : defaultDeviceFound?.label}
        </span>
        <FaCaretDown className="absolute text-blue-400 right-2 top-2/4 -translate-y-2/4" />
      </button>

      {opened && (
        <div className="device-selector-list absolute bottom-full bg-[#20212e] rounded-md mb-1 flex flex-col">
          {options.map((d) => {
            let label = d.label.replace(/\([0-9a-z]+:[0-9a-z]+\)/g, "");

            if (d.deviceId === "default") label = label.replace("Padrão -", "");

            return (
              <button
                key={d.deviceId}
                type="button"
                className="text-white text-left text-nowrap min-h-10 flex items-center hover:bg-slate-700 px-2 py-2 gap-1"
                onClick={() => selectDeviceHandler(d)}
              >
                {d.deviceId === defaultDeviceId && (
                  <FaCheck className="text-blue-400" />
                )}
                <span className="flex-1 flex flex-col">
                  {label}
                  {d.deviceId === "default" && <small>Padrão do sistema</small>}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
